
export function replaceEntry(url: string) {
    history.replaceState({ url: url }, null, url);
}
